import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderDeliveryType',
})
export class OrderDeliveryTypePipe implements PipeTransform {
  orderStatus: string = '';

  /**
   * git the order delievery Type with code number and return his type as a string too
   * @param value string
   * @returns the order Delivery Type string as a translation Key
   */
  transform(value: string | undefined): string {
    switch (value) {
      case 'CASES.DELIVERY_TYPES.0': {
        return 'DELIVERY_TYPE.DEFAULT';
      }
      case 'Standard Lieferung': {
        return 'DELIVERY_TYPE.DEFAULT';
      }
      case 'Standard delivery': {
        return 'DELIVERY_TYPE.DEFAULT';
      }
      case 'CASES.DELIVERY_TYPES.999': {
        return 'DELIVERY_TYPE.INDIVIDUAL_DELIVERY';
      }
      case 'CASES.DELIVERY_TYPES.1': {
        return 'DELIVERY_TYPE.EXPRESS_1';
      }
      case 'Express Lieferung Stufe 1': {
        return 'DELIVERY_TYPE.EXPRESS_1';
      }
      case 'CASES.DELIVERY_TYPES.2': {
        return 'DELIVERY_TYPE.EXPRESS_2';
      }
      case 'Express Lieferung Stufe 2': {
        return 'DELIVERY_TYPE.EXPRESS_2';
      }
      case 'CASES.DELIVERY_TYPES.3': {
        return 'DELIVERY_TYPE.EXPRESS_3';
      }
      case 'Express Lieferung Stufe 3': {
        return 'DELIVERY_TYPE.EXPRESS_3';
      }
    }
    return this.orderStatus;
  }
}
